import { render, staticRenderFns } from "./ApvaIndividuals.vue?vue&type=template&id=dd389f56&"
import script from "./ApvaIndividuals.vue?vue&type=script&lang=js&"
export * from "./ApvaIndividuals.vue?vue&type=script&lang=js&"
import style0 from "./ApvaIndividuals.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports